import React from 'react'
import { RiCloseFill } from 'react-icons/ri'
import { motion } from 'framer-motion'
import { navlinks } from './Sidebar'
import { NavLink } from 'react-router-dom'

interface SideBarProps {
  setSidebarState: React.Dispatch<React.SetStateAction<boolean>>
}

function MobileViewSidebar({ setSidebarState }: SideBarProps) {
  return (
    <motion.aside
      className="fixed top-0 z-50 h-screen w-full bg-[#333333] p-[40px] sm:hidden"
      initial={{ x: '-100%' }}
      animate={{ x: '0%' }}
      exit={{ opacity: '-100%' }}
      transition={{
        type: 'tween',
      }}
    >
      <RiCloseFill onClick={() => setSidebarState(false)} />

      <div className="flex size-full flex-col items-center justify-center gap-8">
        {navlinks.map(({ name, path }, index) => (
          <NavLink
            to={path}
            key={index}
            className={({ isActive }) =>
              isActive
                ? 'font-nunito text-[24px] font-normal leading-[32.74px] transition-colors duration-300   text-[#8C1D40]'
                : 'font-nunito text-[24px] font-normal leading-[32.74px] text-[#F5F5F5]'
            }
          >
            {name}
          </NavLink>
        ))}
      </div>
    </motion.aside>
  )
}

export default MobileViewSidebar
